import { inject, Inject, Injectable, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { catchError, map, Observable, of, tap } from "rxjs";
import ErrorsHandler from "./errors-handler";
import { User } from "./models/user";
import IDisplayUsers from "./ports/i-display-users";
import IManageMessages from "./ports/i-manage-messages"; 
import IManageUsers from "./ports/i-manage-users";
import { MessageAdapterService } from "../adapters/message-adapter.service";
import { UserAdapterService } from "../adapters/user-adapter.service";
import { ResponseUser } from "./models/response-user";

@Injectable()
export default class UsersDisplayer implements IDisplayUsers {  
    user!: User;
    isImageLoading: boolean = false;  
    constructor(
        private _errorHandler: ErrorsHandler,
        private domSanitizer: DomSanitizer,
        @Inject('IManageUsers') private _usersManager: IManageUsers,
        @Inject('IManageMessages') private _messagesManager: IManageMessages) {}

    askUser(): Observable<void> {
        return this._usersManager.getUser().pipe(
            tap(_ => this._messagesManager.add("fetched user")),
            catchError(this._errorHandler.handleError<ResponseUser>('getUser', {} as ResponseUser)),
            map(user => {this.user= user.data; })
        );       
    } 

    askPhoto(): Observable<void> {
        this.isImageLoading = true;
        return this._usersManager.getPhoto().pipe( 
            map(p  => {
                this.isImageLoading = false; 
                var urlCreator = window.URL || window.webkitURL;
                /*this.user.photo = this.domSanitizer.bypassSecurityTrustUrl(
                  urlCreator.createObjectURL(p)
                ); */  
                this.user.photo = this.domSanitizer.sanitize(SecurityContext.HTML, this.domSanitizer.bypassSecurityTrustHtml(urlCreator.createObjectURL(p)));
            } )
        );       
    }  
}